// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  ddg_enabled: true,
  env: 'dev',
  production: false,
  AUTH_API: 'https://auth.dev.xref.com',
  API: 'https://api-questionnaire.dev.xref.com',
  DOMAIN: 'xref.com',
  LOGIN_URL: 'http://login.dev.xref.com/',
  APP_URL: 'https://employer.dev.xref.com'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
